import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class AddressBookService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient,
    private localSt: LocalStorageService) { }

  addressBookList(): Observable<any> {
    const reqEndPoint = 'addressbook';
    return this.http.get(this.serverUrl + reqEndPoint);
  }

  addressBookMakeDefault(addressId): Observable<any> {
    const reqEndPoint = 'addressbook/default';
    return this.http.post(this.serverUrl + reqEndPoint, { id: addressId });
  }

  addNewAddress(data): Observable<any> {
    const reqEndPoint = 'addressbook';
    return this.http.post(this.serverUrl + reqEndPoint, data);
  }

  getEditAddress(addressId): Observable<any> {
    const params = 'addressbook/' + addressId;
    return this.http.get(this.serverUrl + params);
  }

  updateAddress(data): Observable<any> {
    const params = 'addressbook';
    return this.http.put(this.serverUrl + params, data);
  }

  zipCodeListing(data): Observable<any> {
    let params = 'zipcodes/active?';
    if (data.page) {
      params += `page=${data.page}`;
    }
    if (data.limit) {
      params += `&limit=${data.limit}`;
    }
    if (data.search) {
      params += `&search=${data.search}`;
    }
    return this.http.get(this.serverUrl + params);
  }

  activeZipCodeListing(): Observable<any> {
    let params = 'zipcodes/active/all';
    return this.http.get(this.serverUrl + params);
  }

  deleteAddress(addressId): Observable<any> {
    return this.http.request('delete', this.serverUrl + 'addressbook', { body: { id: addressId } });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/address.service.ts